import { useTranslation } from 'react-i18next';
import './loading.scss';
import { logoUrl } from 'app/util/constants';
const Loading = () => {
  const { t } = useTranslation();
  const loadingMessage = t('loading.default');
  return (
    <div className='loading__container' data-testid='loading-component'>
      <img src={logoUrl} width='48px' />
      <div className='loading__text-container'>
        <div className='loading' />
        <p className='loading__text'>{loadingMessage}</p>
      </div>
    </div>
  );
};

export default Loading;
